import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { Notification, Region } from "../../database"
import { getGeneralApiProblem } from "../../services/api/api-problem"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import { withBaseModel } from "../extensions/with-base-model"

/**
 * Model description here for TypeScript hints.
 */

const NotificationStoreProps = {
  ...BaseModelStoreProps,

  InfoNotifications: types.optional(types.array(types.frozen()),[]),
  farmingNotifications: types.optional(types.array(types.frozen()),[]),
  notifications: types.optional(types.array(types.frozen()),[]),
  page: types.maybeNull(types.number),
  pageNotification: types.maybeNull(types.number),
  notifPage: types.maybeNull(types.number),
  meta: types.maybeNull(types.frozen()),

}



export const NotificationsStoreModel = types
  .model("NotificationsStore")
  .props(NotificationStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof NotificationStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init(type: Array<any>){
      self.initModel();
      this.getNotifications(1, type).catch();
    },

    async getNotifications(page: number, type: Array<any>) {
      this.set('loading', true);
      const models = await Notification.fetch({
        page: page,
        type__in: type.join(','),
        per_page: 100
      }).catch((e) => {
        console.warn(e)
        this.set('error', e);
        return []
      }).then((models) => {
      const arr = models.map((model) => model.toArray())
        const regionIds = arr.map((datum) => (datum.data.region_id || '').substring(0, 7));
        const regionModels = Region.fetch({id__in: regionIds})
          .catch((e) => {
            console.warn(e)
            this.set('error', e);
            return []
          }).then((regions) => {
            // const arrRegions = regions.map((region) => region.toArray())
            const data = arr.map((datum) => ({
              ...datum,
              data: {
                ...datum.data,
                region: regions.find((region: Region) => region.getKey() === (datum.data.region_id || '').substring(0, 7))
              }
            }))
            return data
          })
        return regionModels;
      }).finally(() => this.set('loading', false))
      const price = type.length === 1;
      
      price ? this.set("InfoNotifications", models) : this.set("farmingNotifications", models)
      this.set('pageNotification', 2);
      return models
    },

    async getNotificationsNext(type) {
      this.set('loading', true);
      const models = await Notification.fetch({
        page: self.pageNotification || 1,
        type__in: type.join(','),
        per_page: 100
      }).catch((e) => {
        console.warn(e)
        this.set('error', e);
        return []
      }).then((models) => {
        const arr = models.map((model) => model.toArray())
        const regionIds = arr.map((datum) => (datum.data.region_id || '').substring(0, 7));
        const regionModels = Region.fetch({id__in: regionIds})
          .catch((e) => {
            console.warn(e)
            this.set('error', e);
            return []
          }).then((regions) => {
            // const arrRegions = regions.map((region) => region.toArray())
            const data = arr.map((datum) => ({
              ...datum,
              data: {
                ...datum.data,
                region: regions.find((region: Region) => region.getKey() === (datum.data.region_id || '').substring(0, 7))
              }
            }))
            return data
          })
        return regionModels;
      }).finally(() => this.set('loading', false))
      const price = type.length === 1;
      price ? this.set("InfoNotifications", self.InfoNotifications.concat(models))
        : this.set("farmingNotifications", self.farmingNotifications.concat(models))
      this.set('pageNotification', (self.pageNotification || 1) + 1);
      return models
    },

    async fetchNotifications(page, notificationTypes, isInfoNotif) {
      const { tokenStore: { token } } = self.rootStore

      const params = {
        page,
        per_page: 1000,
        type__in: notificationTypes.join(',')
      }
      if (!token) return;
      const result: any = await self.apiSauce.get("/notifications", params, {
        headers: {
          Authorization : `Bearer ${token.access_token}`
        }
      })

      this.set('loading', true);
      if (result.status === 200) {
        const { data: { data, meta } } = result;
        const regionIds = data.map((datum) => (datum.data.region_id || '').substring(0, 7));
        return Region.fetch({
            id__in: regionIds
          })
          .then((regions) => {
            return data.map((datum) => ({
              ...datum,
              data: {
                ...datum.data,
                region: regions.find(
                  (region: Region) => region.getKey() === (datum.data.region_id || '').substring(0, 7)
                )
              }
            }))
          })
          .then((dataWithRegion) => {
            const arrInfoNotif = [...self.InfoNotifications]
            const arrFarmingNotif = [...self.farmingNotifications]
            // const arrNotif = isInfoNotif ? arrInfoNotif : arrFarmingNotif
            // const notifications = [...(page === 1 ? [] : arrNotif), ...dataWithRegion]
            // const setKey = isInfoNotif ? 'InfoNotifications' : 'farmingNotifications'
            // this.set(setKey, notifications)

            const notifFarms = [...(page === 1 ? [] : arrFarmingNotif), ...dataWithRegion];
            const notifInfo = [...(page === 1 ? [] : arrInfoNotif), ...dataWithRegion];
            isInfoNotif ?  this.set('InfoNotifications', notifInfo) : this.set('farmingNotifications', notifFarms)
            this.set('meta', meta)
            this.set('page', page)
            this.set('loading', false);
            this.set('error', null)
            return dataWithRegion
          }, (error) => {
            this.set('loading', false);
            this.set('error', error);
          });
      } else {
        this.set('loading', false);
        this.set('error', getGeneralApiProblem(result))
      }
    },

    async fetchNotification(id) {
      const { tokenStore: { token } } = self.rootStore
      if (!token) return;
      const result: any = await self.apiSauce.get(`/notifications/${id}`, {}, {
        headers: {
          Authorization : `Bearer ${token.access_token}`
        }
      })
      return result.data.data
    },

    async markNotificationsRead(notificationTypes) {
      const { tokenStore: { token } } = self.rootStore
      const params = { type__in: notificationTypes.join(',') }
      if (!token) return;
      const result: any = await self.environment.api.apisauce.put(`/notifications`, params, {
        headers: {
          Authorization : `Bearer ${token.access_token}`
        }
      })
      return result;
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type NotificationsStoreType = Instance<typeof NotificationsStoreModel>
export interface NotificationsStore extends NotificationsStoreType {}
type NotificationsStoreSnapshotType = SnapshotOut<typeof NotificationsStoreModel>
export interface NotificationsStoreSnapshot extends NotificationsStoreSnapshotType {}
export const createNotificationsStoreDefaultModel = () => types.optional(NotificationsStoreModel, {})
